import { ApiError } from '@/api/client';
const FIELDS = new Set([
    'code',
    'name',
    'bonus_amount',
    'fast_registration',
]);
export function eventFieldErrors(error) {
    if (!(error instanceof ApiError) || error.status !== 422)
        return {};
    const detail = error.body?.detail;
    if (typeof detail === 'string') {
        return detail.includes('Бонус') ? { bonus_amount: detail } : {};
    }
    if (!Array.isArray(detail))
        return {};
    const result = {};
    for (const item of detail) {
        if (!item || typeof item !== 'object')
            continue;
        const { loc, msg } = item;
        if (!Array.isArray(loc) || typeof msg !== 'string')
            continue;
        const field = loc.at(-1);
        if (typeof field !== 'string' || !FIELDS.has(field))
            continue;
        const key = field;
        result[key] = key === 'code' ? 'Латиница, цифры, _ и -, до 46 символов' : msg;
    }
    return result;
}
export function eventConflictError(error) {
    return error instanceof ApiError && error.status === 409 ? 'Такой код уже занят' : null;
}
